import React from "react";
import Grid from "@material-ui/core/Grid";
import '../../../../App.scss';
import ICGoldFrame from '../../../../assets/images/ic_frame_mony_yellow.png'
import GameGozine from '../../../../assets/images/ic_frame_mony_yelloww.png'
import ICWhiteFrame from '../../../../assets/images/ic_frame_white.png'
import goldCoin from "../../../../assets/images/ic_coin.png";
import silverCoin from "../../../../assets/images/ic_silver_coin.png";
import Mesh from '../../../../assets/images/mesh.png'
import star from "../../../../assets/images/img_star.png";
import invisibleStar from "../../../../assets/images/invisibleStar.png";
import {numberSplitor} from "../../../../Utility/Func";
import DialogContent from "@material-ui/core/DialogContent";
import Dialog from "@material-ui/core/Dialog";
import TotalPrizeIntro from "./TotalPrizeIntro";
import GreenButton from "../../../../assets/images/green_btn.png";

class TotalPrizesFrame extends React.Component{
    constructor(props){
        super(props)
        this.state={
            showDialog:false,
            dialogData:null
        }
    }
    componentDidMount() {
        const {active}=this.props.data
    }
    setDialogData=()=>{
        const{order,price_value,price_model,prize_val,number,price,locked,stars,active}=this.props.data

        this.setState({
            dialogData:{
                name:`برنزی - مرحله ${order}`,
                id:'2',
                totalPrize:'5',
                score:'45',
                timeRemaining:'22',
                backgroundColor:'rgba(0,0,0,0.4)',
                backgroundImage:Mesh,
                prizeIcon:star,
                startButtonImage:GreenButton,
                startButtonText:'شروع بازی',
                startButtonIcon:price_model==='silver'?silverCoin:goldCoin,
                startButtonIconText:price_value,
                leftSectionBottomImage:star,
                leftSectionTopImage:star,
            },
            showDialog:true
        })
    }
    handleClose=(()=>{
        this.setState({
            showDialog:false
        })
    })
    render() {

        const starCount=3
        const{order,prize_val,number,price,locked,stars,active}=this.props.data
        const key=this.props.identifier
        const { dialogData }=this.state
        return(
            <Grid item  alignItems={"center"} justify={"center"} container xs={12} sm={12} style={{
                margin:'5px',position:'relative'
            }}
                  className={"prize-frame " + (!locked ? 'clickable' : '')}
                // onClick={()=>{
                //     this.setDialogData()
                // }}
            >
                <Dialog
                    open={this.state.showDialog}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    style={{background:'transparent !important',overflow:'visible'}}
                    PaperProps={{
                        style: {
                            backgroundColor: 'transparent',
                            boxShadow: 'none',
                            overflow:'visible',
                        },
                    }}
                >
                    <DialogContent style={{overflow:'visible'}}>
                        <TotalPrizeIntro data={dialogData}/>
                    </DialogContent>
                </Dialog>
                {
                    !(stars==-1) &&
                    <Grid container alignItems={"center"} justify={"space-around"} xs={12} sm={12}
                          className='prize-frame-star-holder'
                          direction={"row-reverse"}
                    >
                        <Grid sm={3} container xs={3} alignItems={"center"} justify={"center"}
                              style={{alignSelf:'center'}}
                        >
                            <img src={stars>0?star:invisibleStar} alt=""/>
                        </Grid>
                        <Grid sm={3} container xs={3} alignItems={"center"} justify={"center"}
                              style={{alignSelf:'self-start'}}
                        >
                            <img src={stars>1?star:invisibleStar}/>
                        </Grid>
                        <Grid sm={3} container xs={3} alignItems={"center"} justify={"center"}
                              style={{alignSelf:'center'}}
                        >
                            <img src={stars>2?star:invisibleStar}/>
                        </Grid>
                    </Grid>
                }

                <Grid alignItems={"center"} justify={"center"} container style={{
                    position:'relative'
                }}>
                    <img src={prize_val!=0?ICGoldFrame:ICWhiteFrame}
                         className={"prize-frame-image " + (active ? 'prize-frame-image-active' : '')}

                         alt=""
                         style={{opacity:!locked?'1':''}}
                    />
                    <p className='prize-frame-score'>
                        {order}
                    </p>
                    {
                        (prize_val!==0) &&
                        <Grid className='prize-frame-bottom-section' >
                            <Grid className='prize-frame-bottom-section-image' container alignItems={"center"} justify={"center"}>
                                <img src={GameGozine} style={{width:'100%',position:'absolute'}} alt=""/>
                                {
                                    (prize_val > 0 && stars >=3) &&
                                    <p/* className='prize-frame-bottom-section-text'*/ style={{zIndex:'10',fontSize:'80%'}}>

                                        <span>
                                             دریافت شد
                                        </span>

                                    </p>
                                }
                                {   (prize_val > 0 && stars <3) &&
                                <p style={{zIndex:'5',fontSize:'80%'}}>
                                          <span>
                                             {numberSplitor(prize_val)}
                                            </span>
                                    تومان
                                </p>


                                }
                            </Grid>
                        </Grid>
                    }
                </Grid>
            </Grid>
        )
    }
}
export default TotalPrizesFrame